import { api } from './api';
import { AppSettingsResponse, UpdateAppSettingsRequest } from '@mygate/common';

export const appSettingsService = {
  /**
   * Get current app settings
   */
  async getSettings(): Promise<AppSettingsResponse['settings']> {
    const response = await api.get<AppSettingsResponse>('/api/staff/app-settings');

    // The api client already throws on non-success, but TypeScript needs assurance about data
    if (!response.data || !response.data.settings) {
      throw new Error('Failed to fetch app settings');
    }

    return response.data.settings;
  },

  /**
   * Update app settings
   */
  async updateSettings(updates: UpdateAppSettingsRequest): Promise<AppSettingsResponse['settings']> {
    const response = await api.put<AppSettingsResponse>('/api/staff/app-settings', updates);

    // The api client already throws on non-success, but TypeScript needs assurance about data
    if (!response.data || !response.data.settings) {
      throw new Error('Failed to update app settings');
    }

    return response.data.settings;
  },
};
